import { atom } from "@reatom/framework";
import { type Swiper } from "swiper/types";

export const swiperAtom = atom<Swiper | null>(null);
export const swiperIndexPage = atom(0);
